import { Injectable } from '@angular/core';
import { TShiftDtoResponse } from '@monorepo/types';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ShiftProvider {
  private shiftData: TShiftDtoResponse = [];
  private currentSelectedShift: TShiftDtoResponse[number] = {
    shift_id: '',
    shift_display_name: '',
  };
  private activeShiftIndex = 0;

  public isMultiShiftConfigured = false;
  public onShiftChange = new Subject();

  constructor() {}

  setShiftData(shiftDTO: TShiftDtoResponse) {
    this.shiftData = shiftDTO;
    this.isMultiShiftConfigured = shiftDTO.length > 1;
    this.shiftData.sort((a, b) => (a.shift_display_name < b.shift_display_name ? -1 : 1));
    if (this.shiftData.length) {
      this.currentSelectedShift = this.shiftData[this.activeShiftIndex];
    }
  }

  changeActiveShift(index: number) {
    this.currentSelectedShift = this.shiftData[index];
    this.activeShiftIndex = index;
    this.onShiftChange.next(this.currentSelectedShift);
  }

  getActiveShiftIndex(): number {
    return this.activeShiftIndex;
  }

  getActiveShift(): TShiftDtoResponse[number] {
    return this.currentSelectedShift;
  }

  getShifts(): TShiftDtoResponse {
    return this.shiftData;
  }

  getShiftDisplayName(shiftId: string) {
    const shift = this.shiftData.find((shift) => {
      return shift.shift_id === shiftId;
    });

    return shift ? shift.shift_display_name : '';
  }

  isMultiShiftSupported = (item) => item.key === '@multiple_shifts' && item.value === false;
}
